// This project has no tsconfig.json, so this reference is needed to pull in
// react-app-env.d.ts's ambient declarations (react-scripts types, *.css
// wildcard module) — an unimported .d.ts otherwise isn't part of this file's
// inferred TS project.
/// <reference path="../../../../../react-app-env.d.ts" />
import React from 'react';
import { Check } from 'lucide-react';
import '../../styles/reservation-steps.css';

interface Step {
  number: number;
  title: string;
}

interface ReservationStepsProps {
  steps: Step[];
  currentStep: number;
}

const ReservationSteps: React.FC<ReservationStepsProps> = ({
  steps,
  currentStep
}) => {
  return (
    <div className="reservation-steps">
      {steps.map((step) => {
        const isCompleted = currentStep > step.number;
        const isActive = currentStep === step.number;
        
        return (
          <div 
            key={step.number}
            className={`step ${isActive ? 'active' : ''} ${isCompleted ? 'completed' : ''}`}
          >
            <div className="step-number">
              {isCompleted ? <Check size={16} /> : step.number}
            </div>
            <div className="step-title">{step.title}</div>
            {step.number < steps.length && (
              <div className="step-connector"></div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default ReservationSteps;